import script from "./eHeader2.vue?vue&type=script&lang=ts&setup=true"
export * from "./eHeader2.vue?vue&type=script&lang=ts&setup=true"

import "./eHeader2.vue?vue&type=style&index=0&id=c264870c&lang=css"
import "./eHeader2.vue?vue&type=style&index=1&id=c264870c&scoped=true&lang=scss"

import exportComponent from "D:\\yuntian\\eso\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c264870c"]])

export default __exports__